import axios from "axios";
import { store } from "./store";

const Api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: "Bearer " + store.token || store.queryToken,
    Accept: "application/json",
  }
});
  
// Api.interceptors.response.use(handleSuccess, null);
  
export default Api;